import { render, staticRenderFns } from "./IdenfitIcon.vue?vue&type=template&id=4f6e18b7&scoped=true&"
import script from "./IdenfitIcon.vue?vue&type=script&lang=js&"
export * from "./IdenfitIcon.vue?vue&type=script&lang=js&"
import style0 from "./IdenfitIcon.vue?vue&type=style&index=0&id=4f6e18b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6e18b7",
  null
  
)

export default component.exports